<template>
  <base-button
    :class="['big-button', `big-button--${type}`, { 'big-button--disabled': isDisabled }]"
    :text="text"
    :is-disabled="isDisabled"
    :is-loading="isLoading"
  >
    <slot />
  </base-button>
</template>

<script setup lang="ts">
import BaseButton from '@/components/common/BaseButton.vue'

type BigButtonType = 'primary' | 'secondary'

interface Props {
  text?: string
  type?: BigButtonType
  isDisabled?: boolean
  isLoading?: boolean
}
withDefaults(defineProps<Props>(), { type: 'primary', isDisabled: false, isLoading: false })
</script>

<style lang="scss">
.big-button {
  $root: #{&};
  padding: 12px 18px;
  color: $white;
  font-size: 16px;
  line-height: 20px;

  & .base-button__content {
    gap: 10px;
  }

  &--primary {
    background-color: $purple;
    transition: background-color 150ms $animationCurve, border-color 150ms $animationCurve;

    &:hover {
      background-color: $purple-light;
    }

    &#{$root}--disabled {
      background-color: $grey-80;
    }
  }

  // Secondary buttons inherit the default style of base-button
  // &--secondary {
  //
  // }
}
</style>
